module.exports = __webpack_public_path__ + "static/media/Ryan-video-sample.91ff5187.jpg";